define('../src/sublayouts/m1-header/m1-header',['jquery'], function($) {

    'use strict';

    var M1_HEADER = function($component) {

        this.$component = $component;

        return this;
    };

    /**
     * Initialise component
     */

    M1_HEADER.prototype.init = function() {
        var _this = this;

        this.mobileMenu();
        this.alignGrid();
        $(window).off('resize.alignGrid').on('resize.alignGrid', function() {
        	_this.alignGrid();
        });
    };

    M1_HEADER.prototype.alignGrid = function() {
        var _this = this;

        var height = (jQuery(window).height() - this.$component.next().height()) / 2 - this.$component.height();
        
        (height < 0) ? (height = '0px') : (height = height.toString() + 'px');

        //console.log(height)

        this.$component.next().css('margin-top', height);
        setTimeout(function(){
            _this.$component.next().css({marginTop: height, opacity: 1});
        },0);

    };

    M1_HEADER.prototype.mobileMenu = function() {
        var _this = this;

        $('.m1-header--menu_mobile').remove();

        $('.m1-header--menubar').append('<div class="m1-header--menu_mobile"><div class="m1-header--menu_mobile--button"><div class="m1-header--menu_mobile--button1"></div><div class="m1-header--menu_mobile--button2"></div></div><div class="m1-header--menu_mobile--wrapper"><img class="m1-header--menu_mobile--img" alt="'+$('.m1-header--logo img').attr('alt')+'" src="'+$('.m1-header--logo img').attr('src')+'"><ul class="m1-header--menu_mobile--list"></ul></div></div>')

        $('.m1-header--menu').find('li').each(function() {
            var href = $(this).find('a').attr('href'),
                text = $(this).text();

                $('.m1-header--menu_mobile--list').append('<li><a href="'+href+'">'+text+'</a></li>')
        });

        $('.m1-header--menu_mobile--button').off('click').on('click', function() {
            $(this).closest('.m1-header--menu_mobile').toggleClass('active');
        });
    };

    return M1_HEADER;
});

